import {RecordForm} from '../forms/RecordForm';


import {useCard} from '../hooks/useCard.ts';
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useParams} from "react-router-dom";
import {AddPageNavigation} from "../navigation/BreadcrumbsNavigation.tsx";


export const AddPage = () => {


    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter')
    }

    const {
        createRecord,
    } = useCard(customerId);


    return (
        <FormPageLayout
            title='Add Card'
            pageNavigation={<AddPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={{customerId: customerId}} handleSubmit={createRecord}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
